<!-- <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar> -->

<!-- <mat-toolbar>
<mat-icon class="me-2" mat-list-icon>playlist_add_check</mat-icon>
<span>
  <h1>{{ 'ORDER_LIST.TITLE' | transloco }}</h1>
</span>
</mat-toolbar> -->

<div class="page-container">
  <!-- Search Section -->
  <div class="search-container">
    <div class="search-controls">
      <!-- Search Type Dropdown -->
      <mat-form-field appearance="outline" class="search-type-select" >
        <mat-label>Search Type</mat-label>
        <mat-select [(value)]="selectedSearchType" (selectionChange)="onSearchTypeChange()" [disabled]="isLoading">
          <!-- <mat-option value="common">
          <mat-icon>search</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.SEARCH' | transloco }}</span>
        </mat-option> -->
        <mat-option value="orderNr">
          <mat-icon>tag</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.ORDER_NR' | transloco }}</span>
        </mat-option>
        <mat-option value="transactionNr">
          <mat-icon>account_balance_wallet</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.TRANSACTION_NR' | transloco }}</span>
        </mat-option>
        <mat-option value="name">
          <mat-icon>person</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.NAME' | transloco }}</span>
        </mat-option>
        <mat-option value="email">
          <mat-icon>email</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.EMAIL' | transloco }}</span>
        </mat-option>
        <mat-option value="phone">
          <mat-icon>phone</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.PHONE' | transloco }}</span>
        </mat-option>
        <mat-option value="registration">
          <mat-icon>directions_car</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.CARID' | transloco }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Search Input -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ getSearchPlaceholder() | transloco }}</mat-label>
      <input matInput
        [type]="getSearchType()"
        [(ngModel)]="currentSearchValue"
        (ngModelChange)="onSearchValueChange()"
        [placeholder]="getSearchPlaceholder() | transloco"
        [disabled]="isLoading">
      <mat-icon matSuffix>{{ getSearchIcon() }}</mat-icon>
      @if (searchValidationError) {
        <mat-hint class="search-error-hint">
          {{ 'ORDER_LIST.SEARCH_MIN_LENGTH_NAME' | transloco }}
        </mat-hint>
      }
    </mat-form-field>

    <!-- Search Button -->
    <button mat-raised-button
      color="primary"
      (click)="executeSearch()"
      [disabled]="isLoading || !currentSearchValue?.trim()"
      class="search-button">
      <mat-icon>search</mat-icon>
      Search
    </button>

    <!-- Clear Search Button -->
    <button mat-stroked-button
      (click)="clearSearch()"
      [disabled]="isLoading"
      class="clear-search-button">
      <mat-icon>clear</mat-icon>
      Clear
    </button>
  </div>
</div>

<!-- Filters Section -->
<div class="filters-container">
  <div class="filters-header" (click)="toggleFilters()">
    <div class="filters-title">
      <mat-icon>filter_list</mat-icon>
      <span>{{ 'ORDER_LIST.FILTERS' | transloco }}</span>
      @if (getActiveFiltersCount() > 0) {
        <mat-chip-set class="filter-count">
          <mat-chip>{{ getActiveFiltersCount() }} {{ 'ORDER_LIST.ACTIVE_FILTERS' | transloco }}</mat-chip>
        </mat-chip-set>
      }
    </div>
    <mat-icon class="expand-icon" [class.expanded]="filtersExpanded">expand_more</mat-icon>
  </div>

  <div class="filters-content" [class.expanded]="filtersExpanded">
    <div class="filters-grid">
      <!-- Multi-Select Status Filter -->
      <div class="filter-group multiple-select">
        <label class="filter-label">{{ 'ORDER_LIST.STATUS' | transloco }}</label>
        <mat-form-field>
          <!-- <mat-label>{{ 'ORDER_LIST.STATUS' | transloco }}</mat-label> -->
          <mat-select [placeholder]="'ORDER_LIST.STATUS' | transloco" [(value)]="selectedStatuses" multiple (selectionChange)="onStatusChange()" [disabled]="isLoading">
            @for (status of statusOptions; track status) {
              <mat-option [value]="status.value">
                {{ status.name }}
              </mat-option>
            }
          </mat-select>
          @if (selectedStatuses && selectedStatuses.length > 0) {
            <mat-hint>
              {{ selectedStatuses.length }} status(es) selected
            </mat-hint>
          }
        </mat-form-field>
      </div>

      <!-- Multi-Select Order Type Filter -->
      <div class="filter-group multiple-select">
        <label class="filter-label">{{ 'ORDER_LIST.ORDER_TYPE' | transloco }}</label>
        <mat-form-field>
          <mat-select [placeholder]="'ORDER_LIST.ORDER_TYPE' | transloco" [(value)]="selectedOrderTypes" multiple (selectionChange)="applyFilters()" [disabled]="isLoading">
            @for (status of orderTypeOptions; track status) {
              <mat-option [value]="status.value">
                {{ status.translation | transloco }}
              </mat-option>
            }
          </mat-select>
          @if (selectedOrderTypes && selectedOrderTypes.length > 0) {
            <mat-hint>
              {{ selectedOrderTypes.length }} order type(s) selected
            </mat-hint>
          }
        </mat-form-field>
      </div>

      @if (availableSubOrgs && availableSubOrgs?.length > 0) {
        <div class="filter-group multiple-select">
          <label class="filter-label">{{ 'TRANSACTION.FILTER.SUB_ORG_IDS' | transloco }}</label>
          <mat-form-field>
            <mat-select [placeholder]="'TRANSACTION.FILTER.SUB_ORG_IDS' | transloco"
              [(value)]="selectedOrgs" multiple (selectionChange)="onStatusChange()" [disabled]="isLoading">
              <mat-option [value]="organization.organizationId">
                {{ organization.organizationName }}
              </mat-option>
              @for (org of availableSubOrgs; track org) {
                <mat-option [value]="org.id">
                  {{ org.label }}
                </mat-option>
              }
            </mat-select>
            @if (selectedOrgs?.length > 0) {
              <mat-hint>
                {{ selectedOrgs?.length }} org(s) selected
              </mat-hint>
            }
          </mat-form-field>
        </div>
      }


      <!-- Created Date Range Filter -->
      <div class="filter-group">
        <label class="filter-label">{{ 'ORDER_LIST.CREATED_DATE' | transloco }}</label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'ORDER_LIST.CREATED_DATE' | transloco }}</mat-label>
          <mat-date-range-input [formGroup]="createdDateRange" [rangePicker]="createdRangePicker" [disabled]="isLoading">
            <input matStartDate formControlName="start" placeholder="{{ 'ORDER_LIST.FROM' | transloco }}">
            <input matEndDate formControlName="end" placeholder="{{ 'ORDER_LIST.TO' | transloco }}">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="createdRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #createdRangePicker></mat-date-range-picker>
          @if (createdDateRange.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>
              Invalid start date
            </mat-error>
          }
          @if (createdDateRange.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>
              Invalid end date
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Booking Begin Date Range Filter -->
      <div class="filter-group">
        <label class="filter-label">{{ 'ORDER_LIST.BOOKING_BEGIN' | transloco }}</label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'ORDER_LIST.BOOKING_BEGIN' | transloco }}</mat-label>
          <mat-date-range-input [formGroup]="bookingBeginRange" [rangePicker]="bookingBeginRangePicker" [disabled]="isLoading">
            <input matStartDate formControlName="start" placeholder="{{ 'ORDER_LIST.FROM' | transloco }}">
            <input matEndDate formControlName="end" placeholder="{{ 'ORDER_LIST.TO' | transloco }}">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="bookingBeginRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #bookingBeginRangePicker></mat-date-range-picker>
          @if (bookingBeginRange.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>
              Invalid start date
            </mat-error>
          }
          @if (bookingBeginRange.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>
              Invalid end date
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Booking End Date Range Filter -->
      <div class="filter-group">
        <label class="filter-label">{{ 'ORDER_LIST.BOOKING_END' | transloco }}</label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'ORDER_LIST.BOOKING_END' | transloco }}</mat-label>
          <mat-date-range-input [formGroup]="bookingEndRange" [rangePicker]="bookingEndRangePicker" [disabled]="isLoading">
            <input matStartDate formControlName="start" placeholder="{{ 'ORDER_LIST.FROM' | transloco }}">
            <input matEndDate formControlName="end" placeholder="{{ 'ORDER_LIST.TO' | transloco }}">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="bookingEndRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #bookingEndRangePicker></mat-date-range-picker>
          @if (bookingEndRange.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>
              Invalid start date
            </mat-error>
          }
          @if (bookingEndRange.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>
              Invalid end date
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="filter-actions">
      <button mat-raised-button color="primary" (click)="applyFilters()" [disabled]="isLoading">
        <mat-icon>search</mat-icon>
        {{ 'ORDER_LIST.APPLY_FILTERS' | transloco }}
      </button>
      <button mat-stroked-button (click)="clearFilters()" [disabled]="isLoading">
        <mat-icon>clear</mat-icon>
        {{ 'ORDER_LIST.CLEAR_FILTERS' | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Results Section -->
<div class="results-section">
  <mat-paginator
    #paginator
    [length]="totalData"
    [pageSizeOptions]="pageSizes"
    showFirstLastButtons
    [disabled]="isLoading"
  ></mat-paginator>

  <div class="overflow-auto">
    <table mat-table matSort [dataSource]="dataSource" class="results-table mat-elevation-z2">
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.ORDER_NR' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.orderNr }} </td>
      </ng-container>

      <ng-container matColumnDef="organizationName">
        <th mat-header-cell *matHeaderCellDef >{{ 'ORDER_LIST.ORGANIZATION_NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.organizationName }}</td>
      </ng-container>

      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.customerName }}</td>
      </ng-container>

      <ng-container matColumnDef="cellular">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.PHONE' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.cellular }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.EMAIL' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.email }} </td>
      </ng-container>

      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef >{{ 'ORDER_LIST.COMMENT' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.comment }} </td>
      </ng-container>

      <ng-container matColumnDef="parkingFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PARKING_ORDER_TIME_EDIT.PARKING_FROM' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.parkingFrom | date:'yyyy-MM-dd HH:mm' }} </td>
      </ng-container>

      <ng-container matColumnDef="parkingTo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PARKING_ORDER_TIME_EDIT.PARKING_TO' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.parkingTo | date:'yyyy-MM-dd HH:mm' }} </td>
      </ng-container>

      <ng-container matColumnDef="orderDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.DATE' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.orderDate | date:'yyyy-MM-dd HH:mm' }} </td>
      </ng-container>

      <ng-container matColumnDef="carId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.CARID' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.carId }} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.STATUS' | transloco }}</th>
        <td mat-cell *matCellDef="let order">
          <app-status-badge [text]="order.status" [isPayment]="true"></app-status-badge>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let order; columns: displayedColumns;" (click)="goToOrder(order.orderId)" class="clickable-row"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
          <div class="no-data-content">
            <mat-icon>search_off</mat-icon>
            <span>{{ 'ORDER_LIST.NO_MATCH' | transloco }}</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
</div>
